import { StockPickResponse } from './../../models/stock-pick/stock-pick-response.model';
import { environment } from './../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class StockPickService {

	httpOptions = {
		headers: new HttpHeaders({
			'Content-type': 'application/json'
		})
	};

	constructor(private http: HttpClient) {
		this.http = http;
	}

	getStockType(): Observable<StockPickResponse[]> {

		const URL = environment.inbound_url + '/api/v1/parts-movement/getAllStockTypes';

		return this.http.get<StockPickResponse[]>(URL);
	}
}
